const clientTypes = [
    {
        name: "CLIENT",
        value: 1
    },
    {
        name: "SUBCONTRACTORS",
        value: 2
    },
    {
        name: "SUPPLIER",
        value: 3
    },
    {
        name: "OTHER",
        value: 4
    }
];

export default clientTypes;